const IconMedical = () => (
  <svg
    width="46px"
    height="47px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.217 5.697h2.548a2.567 2.567 0 1 0 0-5.133H4.782A4.699 4.699 0 0 0 .083 5.263v13.85c0 6.988 4.776 12.861 11.241 14.534-1.867 12.23 14.29 20.13 22.667 9.644l1.46-1.826a8.389 8.389 0 1 0-3.55-2.135l-1.119 1.398c-5.698 7.133-16.7 1.727-15.367-6.607 8.143-.17 14.691-6.824 14.691-15.008V5.263A4.699 4.699 0 0 0 25.407.564h-3.19a2.567 2.567 0 0 0 0 5.133h2.756v13.416c0 5.456-4.423 9.878-9.878 9.878-5.456 0-9.878-4.422-9.878-9.878V5.697ZM37.86 36.683a3.256 3.256 0 1 0 0-6.512 3.256 3.256 0 0 0 0 6.512Z"
      fill="#5FA3A9"
    />
  </svg>
);

export default IconMedical;
